import { useContext } from "react";
import { Button, Flex, MLink, MHeader } from "@cisco/spaces-dash-lib-styleguide";
import Logo from "../../../assets/images/dnaspaces/cisco-dnaspaces-logo.svg";
import { I18nContext } from "../../../contexts/i18nContext";
import { PropertiesContext } from "../../../contexts/propertiesContext";
import "../../login-page-about-section/login-page-about-section.css";

export function LogoComponent(): JSX.Element {
  return <img src={Logo} alt="Cisco Spaces Logo" />;
}

export function LoginPageHeader(): JSX.Element {
  const i18n = useContext(I18nContext);
  const context = useContext(PropertiesContext);

  if (!i18n || !context) {
    throw new Error("LoginPageHeader must be used within proper context providers");
  }

  const { t } = i18n;
  const { properties } = context;

  return (
    <MHeader
      className="partnerTextName"
      style={{ background: "transparent" }}
      logo={<LogoComponent />}
      productName={` | ${t("auth.login.login-partner-base.partners-text", { ns: "spaces-dash-app-partners-login" })}`}
    >
      {properties && properties.partnerDocumentationPublicLink && (
        <Flex>
          <Button kind="secondary">
            <MLink href={properties.partnerDocumentationPublicLink} target="_blank">
              {t("auth.login.login-partner-base.documentation-text", { ns: "spaces-dash-app-partners-login" })}
            </MLink>
          </Button>
        </Flex>
      )}
    </MHeader>
  );
}
